import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

import { useEffect, useState } from "react";

import React from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { getCouponListAsync } from "../../../../../../app/slices/checkoutSlice/CheckoutSlice";
import { addOrUpdateCartAsync } from "../../../../../../app/slices/cartSlice/CartSlice";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";

export const CouponComponent = ({ onCloseModal, modalType }: any) => {
  const dispatch = useAppDispatch();

  const [couponData, setCouponData] = useState<any>([]);
  const { addTocart } = useAppSelector((state) => state.CartState);
  const [couponCode, setCouponCode] = useState("");

  const handleCouponChange = (e: any) => {
    setCouponCode(e.target.value);
  };
  useEffect(() => {
    if (modalType) {
      dispatch(getCouponListAsync()).then((response: any) => {
        if (response?.payload?.status === 200) {
          setCouponData(response?.payload?.data?.coupons);
        }
      });
    }
  }, [modalType]);
  const applyCoupon = (coupon_code: any) => {
    const appliedCoupon =
      couponData?.find((coupon: any) => coupon?.coupon_code === coupon_code) ??
      null;
    if (appliedCoupon && appliedCoupon?.savings !== 0) {
      const quantities = addTocart?.data?.reduce((acc: any, item: any) => {
        acc[item.sku_id] = item.quantity;
        return acc;
      }, {});
      const payload: any = {
        skus: Object.entries(quantities)?.map(([sku, quantity]) => ({
          sku: Number(sku),
          quantity,
        })),
        coupon_code: coupon_code,
      };
      dispatch(addOrUpdateCartAsync(payload));
      onCloseModal();
    } else {
      dispatch(
        showSnackbar({
          message: "Coupon is not applicable",
          severity: "error",
          autoHide: 2000,
        })
      );
    }
  };
  return (
    <>
      <header>
        <div style={{ paddingBottom: "10px" }} className="tf-search-sticky">
          <form>
            <div className="coupon-box">
              <input
                type="text"
                placeholder="Enter Coupon code"
                style={{ paddingLeft: "5%" }}
                value={couponCode}
                onChange={handleCouponChange}
              />
              <a
                className="tf-btn btn-sm radius-3 btn-fill btn-icon animate-hover-btn"
                onClick={() => {
                  applyCoupon(couponCode);
                  setCouponCode("");
                }}
              >
                Apply
              </a>
            </div>
          </form>
        </div>
      </header>
      <div className="canvas-wrapper" style={{ maxHeight: "70vh" }}>
        <div className="canvas-body p-0">
          <div className="tf-search-content">
            <div
              className="card"
              style={{ fontFamily: "Albert Sans, sans-serif" }}
            >
              <div className="card-body px-4">
                <h4 className="fs-16 fw-6">Available Coupons</h4>
                {couponData?.map((item: any, index: number) => {
                  return (
                    <>
                      <div
                        className="d-flex pointer mt-4 justify-content-between align-items-start"
                        key={index}
                      >
                        <div>
                          <div className="_31TEE">
                            <div className="Lh_wF _2WruX">
                              <img
                                className="_3vTc2"
                                width="20"
                                height="20"
                                data-src={`${process.env.REACT_APP_API_URL}${item?.icon}`}
                                src={`${process.env.REACT_APP_API_URL}${item?.icon}`}
                                // alt="coupon logo"
                              />

                              <span className="_3vb2y">
                                {item?.coupon_code}
                                <span className="I1PRc"></span>
                                <span className="_2YWry"></span>
                              </span>
                            </div>
                          </div>
                          <p className="address-text">
                            <b>{item?.coupon_description}</b>
                          </p>
                          <p className="mb-2 address-text">
                            {item?.terms_and_conditions}
                          </p>
                          <button
                            style={
                              item?.savings === 0
                                ? {
                                    backgroundColor: "rgba(0,0,0,0.12)",
                                    cursor: "not-allowed",
                                  }
                                : {}
                            }
                            className={
                              item?.savings === 0
                                ? "tf-btn mb-2 animate-hover-btn radius-3 justify-content-center btn-add-note"
                                : "tf-btn mb-2 animate-hover-btn radius-3 justify-content-center orange-b btn-add-note active"
                            }
                            disabled={item?.savings === 0}
                            onClick={() => applyCoupon(item.coupon_code)}
                          >
                            <span>Apply Coupon</span>
                          </button>
                        </div>
                      </div>
                      <hr />
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
